module.exports = __webpack_public_path__ + "img/reviewing-en.8e59dcbe.png";